import { CountUp } from "countup.js";
import { animate, stagger } from "motion";
import Swiper from "swiper";
import { A11y, Autoplay, Navigation, Pagination } from "swiper/modules";
import "@styles/components/slider.css";

const runCounter = (el) => {
  const useGrouping = el.dataset.useGrouping;
  const decimalPlaces = el.dataset.decimalPlaces;
  const end = el.dataset.end;

  const opts = {
    useGrouping: !!+useGrouping,
  };

  if (decimalPlaces) {
    opts.decimalPlaces = decimalPlaces;
  }

  const counter = new CountUp(el, end, opts);

  counter.start();
};

document.querySelectorAll(".element-stats").forEach((el) => {
  const container = el.querySelector(".swiper");
  const numSlides = el.querySelectorAll(".swiper-slide").length;

  if (numSlides > 1) {
    const swiper = new Swiper(container, {
      modules: [A11y, Autoplay, Navigation, Pagination],
      autoplay: {
        delay: 3000,
      },
      speed: 750,
      loop: true,
      navigation: {
        nextEl: el.querySelector(".slider-button-next"),
        prevEl: el.querySelector(".slider-button-prev"),
      },
      pagination: {
        el: el.querySelector(".slider-pagination"),
        clickable: true,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      breakpoints: {
        1024: {
          slidesPerView: 2,
        },
        1400: {
          slidesPerView: 3,
        },
      },
    });

    swiper.autoplay.stop();

    const handleActiveSlide = (activeSlide) => {
      if (!activeSlide.classList.contains("did-run")) {
        const counters = activeSlide.querySelectorAll("[data-counter]");
        counters.forEach((counter) => runCounter(counter));

        activeSlide.classList.add("did-run");
      }
    };

    swiper.on("autoplayStart", () => {
      const activeSlide = swiper.slides[swiper.activeIndex];
      handleActiveSlide(activeSlide);
    });

    swiper.on("slideChange", () => {
      const activeSlide = swiper.slides[swiper.activeIndex];
      handleActiveSlide(activeSlide);
    });

    const observer = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          swiper.autoplay.start();
          observer.disconnect();
        }
      },
      {
        threshold: [0.7],
      },
    );

    observer.observe(el);
  }
});
